'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCart(id_$_lo, id_$_hi, store, items, storeCartState, opened, archived) {
  this.pd = 0;
  this.pe = 0;
  this.nq = null;
  this.oG = null;
  this.wH = null;
  this.uE = null;
  this.wG = null;
  this.am7 = null;
  this.am8 = false;
  this.pd = id_$_lo;
  this.pe = id_$_hi;
  this.nq = store;
  this.oG = items;
  this.wH = storeCartState;
  this.uE = opened;
  this.wG = archived;
}
export { $c_Lmealorama_StoreCart as $c_Lmealorama_StoreCart };
$p = $c_Lmealorama_StoreCart.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCart;
/** @constructor */
function $h_Lmealorama_StoreCart() {
}
export { $h_Lmealorama_StoreCart as $h_Lmealorama_StoreCart };
$h_Lmealorama_StoreCart.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 137276863, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_StoreCart)) {
    var x_$_lo = this.pd;
    var x_$_hi = this.pe;
    var $x_5 = x$0;
    var x$1_$_lo = $x_5.pd;
    var x$1_$_hi = $x_5.pe;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.nq;
      var x$2$1 = x$0.nq;
      var $x_4 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.oG;
      var x$4 = x$0.oG;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.wH;
      var x$6 = x$0.wH;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : (x$5 === x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.uE;
      var x$8 = x$0.uE;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.wG;
      var x$10 = x$0.wG;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "StoreCart";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.pd, this.pe);
      break;
    }
    case 1: {
      return this.nq;
      break;
    }
    case 2: {
      return this.oG;
      break;
    }
    case 3: {
      return this.wH;
      break;
    }
    case 4: {
      return this.uE;
      break;
    }
    case 5: {
      return this.wG;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.hE = (function() {
  if ((!this.am8)) {
    this.am7 = this.nq.sN;
    this.am8 = true;
  }
  return this.am7;
});
function $isArrayOf_Lmealorama_StoreCart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jY)));
}
export { $isArrayOf_Lmealorama_StoreCart as $isArrayOf_Lmealorama_StoreCart };
var $d_Lmealorama_StoreCart = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCart, "mealorama.StoreCart", ({
  jY: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_StoreCart as $d_Lmealorama_StoreCart };
//# sourceMappingURL=mealorama.-Store-Cart.js.map
